import SpaTracking from './SpaTracking';

export default SpaTracking;
